
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import gorog from "../../assets/gorog.png"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarGorog({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar görög fordító</title>
                <meta name='description' content="Ingyenes magyar görög fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar görög fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-gorog-fordito" />
            </Helmet>
            <h1>Magyar görög fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A magyar és görög nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={gorog} alt="görög zászló"></img>
                </div>

                <p>Íme néhány fő hasonlóság és különbség a magyar és a görög nyelv között:</p>

                <h3>Hasonlóságok</h3>
                <ul>
                    <li><b>Gazdag történelem</b>: A magyarnak és a görögnek egyaránt hosszú és gazdag nyelvtörténete van. A magyar eredete a finnugor nyelvcsaládból származik, míg a görög az indoeurópai nyelvcsalád hellén ágához tartozik. Mindkét nyelv évszázadok során fejlődött, és hatással voltak rájuk a szomszédos nyelvek.</li>

                    <li><b>Egyedi szókincs</b>: Mindkét nyelv egyedi szókincsekkel rendelkezik, amelyek nincsenek szoros rokonságban más európai nyelvekkel. A magyar szavakat a szomszédos nyelvekből kölcsönzött, például német, török és szláv nyelvekből. A görög gazdag szókinccsel rendelkezik, amely jelentős hatással van az ókori görög, latin és más nyelvekre.</li>
                </ul>
                <h3>Különbségek</h3>

                <h4>Nyelvcsalád</h4>
                <ul>
                    <li><b>Magyar</b>: A magyar finnugor nyelv, az uráli nyelvcsalád része. Nem kapcsolódik szorosan más európai nyelvekhez, és egyedülálló nyelvi örökséggel rendelkezik.</li>
                    <li><b>Görög</b>: A görög egy indoeurópai nyelv, kifejezetten a hellén ághoz tartozik. Ez az egyik legrégebbi feljegyzett nyelv, jelentős történelmi és kulturális jelentőséggel bír.</li>
                </ul>

                <h4>Nyelvtan</h4>
                <ul>
                    <li><b>Magyar</b>: A magyarnak összetett agglutinatív nyelvtana van. A szótövekhez fűződő toldalékrendszert használja, hogy kifejezze az olyan nyelvtani jellemzőket, mint az idő, a mód, a szám és a birtoklás. A magyar nyelvben gazdag főnévi esetrendszer is található a nyelvtani szerepek jelzésére.</li>
                    <li><b>Görög</b>: a görög nyelvnek szintetikusabb a nyelvtana a magyarhoz képest. Van benne főnévi ragozási és ragozási rendszer a nyelvtani kapcsolatok jelzésére. A görög nyelvnek számos főnévi esete és igealakja van a különböző nyelvtani funkciók kifejezésére.</li>
                </ul>
                <h4>Ábécé</h4>
                <ul>
                    <li><b>Magyar</b>: A magyar a latin ábécét használja néhány további diakritikus jellel. 44 betűje van, beleértve a digráfokat és az ékezetes karaktereket.</li>
                    <li><b>Görög</b>: A görögnek megvan a maga egyedi ábécéje, a görög ábécé, amely a világ egyik legrégebbi írásrendszere. 24 betűből áll, beleértve a kis- és nagybetűket is.</li>
                </ul>
                <h4>Kiejtés</h4>
                <ul>
                    <li><b>Magyar</b>: A magyar nyelvnek egyszerű hangrendszere van, következetes kiejtési szabályokkal. Ha megtanulja az egyes betűk és betűkombinációk kiejtését, könnyebbé válik a magyar szavak olvasása és kiejtése.</li>
                    <li><b>Görög</b>: A görög kiejtése kihívást jelenthet a nem anyanyelvi beszélők számára a különféle magánhangzók, mássalhangzó-csoportok és hangsúlyozások miatt. A görög nyelvnek sajátos szabályai vannak a szavakban való hangsúlyelhelyezésre.</li>
                </ul>
                <h4>Mondatszerkezet</h4>
                <ul>
                    <li><b>Magyar</b>: A magyar nyelvnek van Subject-Object-Ige (SOV) szórendje, ami eltér a legtöbb európai nyelv tipikus szórendjétől. Az ige általában a mondat végére kerül.</li>
                    <li><b>Görög</b>: A görög nyelvnek rugalmas szórendje van, de az alapértelmezett szórend a Tárgy-Ige-Objektum (SVO). A görög nyelv különböző szórendeket is alkalmazhat hangsúly vagy stilisztikai célokra.</li>

                </ul>
                <div className="sectionbottom">
                    <Link to="/gorog-magyar-fordito">Görög magyar fordító</Link>
                    <img src={gorog} alt="görög zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>


            </section>





        </>

    )
}

export default MagyarGorog;